// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { State, StateT } from '../tbs/state.js';


export class PlayerView implements flatbuffers.IUnpackableObject<PlayerViewT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PlayerView {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPlayerView(bb:flatbuffers.ByteBuffer, obj?:PlayerView):PlayerView {
  return (obj || new PlayerView()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPlayerView(bb:flatbuffers.ByteBuffer, obj?:PlayerView):PlayerView {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PlayerView()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

authPlayerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

state(obj?:State):State|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new State()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPlayerView(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addAuthPlayerId(builder:flatbuffers.Builder, authPlayerId:number) {
  builder.addFieldInt32(0, authPlayerId, -1);
}

static addState(builder:flatbuffers.Builder, stateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, stateOffset, 0);
}

static endPlayerView(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PlayerViewT {
  return new PlayerViewT(
    this.authPlayerId(),
    (this.state() !== null ? this.state()!.unpack() : null)
  );
}


unpackTo(_o: PlayerViewT): void {
  _o.authPlayerId = this.authPlayerId();
  _o.state = (this.state() !== null ? this.state()!.unpack() : null);
}
}

export class PlayerViewT implements flatbuffers.IGeneratedObject {
constructor(
  public authPlayerId: number = -1,
  public state: StateT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const state = (this.state !== null ? this.state!.pack(builder) : 0);

  PlayerView.startPlayerView(builder);
  PlayerView.addAuthPlayerId(builder, this.authPlayerId);
  PlayerView.addState(builder, state);

  return PlayerView.endPlayerView(builder);
}
}
